<div class="container">
  <section class="form--section">
    <form method="post" accept-charset="utf-8" class="form form-horizontal -calculate -confirm -contact -risk-test"
      action="/risk-test">
      <div style="display:none;"><input type="hidden" name="_method" value="POST"></div>
      <header class="heading-topic">
        <h2 class="topic-title">{{language.investingbyrisktopic}}</h2>
      </header>

      <section class="group-section">
        <div class="row" *ngIf="isNewbee">
          <div class="col-md-6">
            <div class="form-group">
              <div class="name--section">
                <span class="label">{{language.investingbyrisknewbee}}</span>
                <span class="input">
                  <app-input></app-input>
                </span>
              </div>
            </div>
          </div>
        </div>

        <p class="note"><em>{{language.investingbyrisknote1}}</em>
          {{language.investingbyrisknote2}}</p>
        <p *ngIf="!complete" class="red-note">{{language.investingbyrisknoteerror}}</p>
      </section>

      <!-- 1 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>1</em></span>
          <span class="text">{{language.investingbyriskquestion1}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline  icheck-label icheck[enqs9] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_1" [checked]="q1_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionOneScore($event)"></app-radio>
              <span>{{language.investingbyriskq1answer1}}</span>
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline  icheck-label icheck[kssp1] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_1" [checked]="q1_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionOneScore($event)"></app-radio>
              {{language.investingbyriskq1answer2}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline  icheck-label icheck[uoltk] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_1" [checked]="q1_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionOneScore($event)"></app-radio>
              {{language.investingbyriskq1answer3}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <label class="radio-inline  icheck-label icheck[hfvv5] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_1" [checked]="q1_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionOneScore($event)"></app-radio>
              {{language.investingbyriskq1answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /1 -->

      <!-- 2 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>2</em></span>
          <span class="text">{{language.investingbyriskquestion2}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[pfmgk] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_2" [checked]="q2_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionTwoScore($event)"></app-radio>
              {{language.investingbyriskq2answer1}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[xgf4o] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_2" [checked]="q2_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionTwoScore($event)"></app-radio>
              {{language.investingbyriskq2answer2}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[lqo4r] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_2" [checked]="q2_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionTwoScore($event)"></app-radio>
              {{language.investingbyriskq2answer3}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[05it6] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_2" [checked]="q2_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionTwoScore($event)"></app-radio>
              {{language.investingbyriskq2answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /2 -->

      <!-- 3 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>3</em></span>
          <span class="text">{{language.investingbyriskquestion3}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[px7h8] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_3" [checked]="q3_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionThreeScore($event)"></app-radio>
              {{language.investingbyriskq3answer1}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[k7c2a] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_3" [checked]="q3_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionThreeScore($event)"></app-radio>
              {{language.investingbyriskq3answer2}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[rhjim] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_3" [checked]="q3_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionThreeScore($event)"></app-radio>
              {{language.investingbyriskq3answer3}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[h2kwl] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_3" [checked]="q3_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionThreeScore($event)"></app-radio>
              {{language.investingbyriskq3answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /3 -->

      <!-- 4 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>4</em></span>
          <span class="text">{{language.investingbyriskquestion4}}</span>
        </h6>
        <ul class="list-form list-unstyled row checkbox--section">
          <li class="col-md-12 col-lg-6">
            <label class="checkbox-inline  icheck-label icheck[8z79b] needsclick">
              <app-checkbox [checked]="q4_1" [checkboxValue]="1" (returnCheckboxValue)="setQuestionFourScore($event)">
              </app-checkbox>
              {{language.investingbyriskq4answer1}}
            </label> </li>
          <li class="col-md-12 col-lg-6">
            <label class="checkbox-inline  icheck-label icheck[bks6i] needsclick">
              <app-checkbox [checked]="q4_2" [checkboxValue]="2" (returnCheckboxValue)="setQuestionFourScore($event)">
              </app-checkbox>
              {{language.investingbyriskq4answer2}}
            </label> </li>
          <li class="col-md-12 col-lg-6">
            <label class="checkbox-inline  icheck-label icheck[5unk4] needsclick">
              <app-checkbox [checked]="q4_3" [checkboxValue]="3" (returnCheckboxValue)="setQuestionFourScore($event)">
              </app-checkbox>
              {{language.investingbyriskq4answer3}}
            </label> </li>
          <li class="col-md-12 col-lg-6">
            <label class="checkbox-inline  icheck-label icheck[1p9pb] needsclick">
              <app-checkbox [checked]="q4_4" [checkboxValue]="4" (returnCheckboxValue)="setQuestionFourScore($event)">
              </app-checkbox>
              {{language.investingbyriskq4answer4}}
            </label> </li>
        </ul>
        <p class="remark">{{language.investingbyriskq4note}}</p>
      </section>
      <!-- /4 -->

      <!-- 5 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>5</em></span>
          <span class="text">{{language.investingbyriskquestion5}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[907i1] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_5" [checked]="q5_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionFiveScore($event)"></app-radio>
              {{language.investingbyriskq5answer1}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[ve3fc] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_5" [checked]="q5_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionFiveScore($event)"></app-radio>
              {{language.investingbyriskq5answer2}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[emxlz] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_5" [checked]="q5_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionFiveScore($event)"></app-radio>
              {{language.investingbyriskq5answer3}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[s3jvv] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_5" [checked]="q5_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionFiveScore($event)"></app-radio>
              {{language.investingbyriskq5answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /5 -->

      <!-- 6 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>6</em></span>
          <span class="text">{{language.investingbyriskquestion6}}</span>
        </h6>
        <ul class="list-form list-unstyled">
          <li>
            <label class="radio-inline  icheck-label icheck[uaidq] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_6" [checked]="q6_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionSixScore($event)"></app-radio>
              {{language.investingbyriskq6answer1}}
            </label>
          </li>
          <li>
            <label class="radio-inline  icheck-label icheck[0mihl] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_6" [checked]="q6_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionSixScore($event)"></app-radio>

              {{language.investingbyriskq6answer2}}
            </label>
          </li>
          <li>
            <label class="radio-inline  icheck-label icheck[lo7zk] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_6" [checked]="q6_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionSixScore($event)"></app-radio>

              {{language.investingbyriskq6answer3}}
            </label>
          </li>
          <li>
            <label class="radio-inline  icheck-label icheck[fl63g] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_6" [checked]="q6_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionSixScore($event)"></app-radio>

              {{language.investingbyriskq6answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /6 -->

      <!-- 7 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>7</em></span>
          <span class="text">{{language.investingbyriskquestion7}}</span>
        </h6>

        <ul class="list-form list-unstyled">
          <li>
            <span *ngIf="flag == 'th';else elseimg7" class="show-img">
              <img src="assets/images/graph-test-investment@2x.png" class="img-fluid" alt="graph test investment"
                data-rjs="2" data-rjs-processed="true" width="402" height="188">
            </span>
            <ng-template #elseimg7>
              <span class="show-img">
                <img src="assets/images/graph-test-investment@2x_en.png" class="img-fluid" alt="graph test investment"
                  data-rjs="2" data-rjs-processed="true" width="402" height="188">
              </span>
            </ng-template>
          </li>
          <li>
            <label class="radio-inline  icheck-label icheck[9ewrx] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_7" [checked]="q7_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionSevenScore($event)"></app-radio>
              {{language.investingbyriskq7answer1}}
            </label>
          </li>
          <li>
            <label class="radio-inline  icheck-label icheck[je58u] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_7" [checked]="q7_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionSevenScore($event)"></app-radio>

              {{language.investingbyriskq7answer2}}
            </label>
          </li>
          <li>
            <label class="radio-inline  icheck-label icheck[m1bk5] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_7" [checked]="q7_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionSevenScore($event)"></app-radio>

              {{language.investingbyriskq7answer3}}
            </label>
          </li>
          <li>
            <label class="radio-inline  icheck-label icheck[ul328] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_7" [checked]="q7_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionSevenScore($event)"></app-radio>

              {{language.investingbyriskq7answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /7 -->

      <!-- 8 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>8</em></span>
          <span class="text">{{language.investingbyriskquestion8}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[cn0zn] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_8" [checked]="q8_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionEightScore($event)"></app-radio>
              {{language.investingbyriskq8answer1}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[x1wq1] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_8" [checked]="q8_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionEightScore($event)"></app-radio>

              {{language.investingbyriskq8answer2}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[jtkbf] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_8" [checked]="q8_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionEightScore($event)"></app-radio>

              {{language.investingbyriskq8answer3}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[s650p] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_8" [checked]="q8_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionEightScore($event)"></app-radio>

              {{language.investingbyriskq8answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /8 -->

      <!-- 9 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>9</em></span>
          <span class="text">{{language.investingbyriskquestion9}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[5q8oo] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_9" [checked]="q9_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionNineScore($event)"></app-radio>
              {{language.investingbyriskq9answer1}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[bsei6] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_9" [checked]="q9_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionNineScore($event)"></app-radio>
              {{language.investingbyriskq9answer2}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[49qlp] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_9" [checked]="q9_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionNineScore($event)"></app-radio>
              {{language.investingbyriskq9answer3}}
            </label>
          </li>
          <li class="col-sm-6 col-md-6 col-lg-6">
            <label class="radio-inline  icheck-label icheck[3cfpj] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_9" [checked]="q9_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionNineScore($event)"></app-radio>
              {{language.investingbyriskq9answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /9 -->

      <!-- 10 -->
      <section class="group-section">
        <h6 class="title-label">
          <span rel="border-circle"><em>10</em></span>
          <span class="text">{{language.investingbyriskquestion10}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[r0fol] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_10" [checked]="q10_1" [choiceValue]="1"
                (returnSelectValue)="setQuestionTenScore($event)"></app-radio>

              {{language.investingbyriskq10answer1}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[h7go8] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_10" [checked]="q10_2" [choiceValue]="2"
                (returnSelectValue)="setQuestionTenScore($event)"></app-radio>

              {{language.investingbyriskq10answer2}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[qiig1] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_10" [checked]="q10_3" [choiceValue]="3"
                (returnSelectValue)="setQuestionTenScore($event)"></app-radio>

              {{language.investingbyriskq10answer3}}
            </label>
          </li>
          <li class="col-md-12 col-lg-6">
            <label class="radio-inline  icheck-label icheck[3o6pv] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_10" [checked]="q10_4" [choiceValue]="4"
                (returnSelectValue)="setQuestionTenScore($event)"></app-radio>
              {{language.investingbyriskq10answer4}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /10 -->

      <!-- 11 -->
      <section class="group-section">
        <p class="note"><em>{{language.investingbyriskq11note1}}</em> {{language.investingbyriskq11note2}}</p>
        <h6 class="title-label">
          <span rel="border-circle" style="width: 66px;"><em>11</em></span>
          <span class="text">{{language.investingbyriskquestion11}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-sm-4 col-md-4 col-lg-4">
            <label class="radio-inline  icheck-label icheck[jze04] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_11" (returnSelectValue)="setQuestionElevenScore($event)"
                [choiceValue]="1" [checked]="q11_1"></app-radio>
              {{language.investingbyriskq11answer1}}
            </label>
          </li>
          <li class="col-sm-4 col-md-4 col-lg-4">
            <label class="radio-inline  icheck-label icheck[8t9rl] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_11" (returnSelectValue)="setQuestionElevenScore($event)"
                [choiceValue]="2" [checked]="q11_2"></app-radio>
              {{language.investingbyriskq11answer2}}
            </label>
          </li>
          <li class="col-sm-4 col-md-4 col-lg-4">
            <label class="radio-inline  icheck-label icheck[98tve] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_11" (returnSelectValue)="setQuestionElevenScore($event)"
                [choiceValue]="3" [checked]="q11_3"></app-radio>
              {{language.investingbyriskq11answer3}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /11 -->

      <!-- 12 -->
      <section class="group-section">
        <p class="note"><em>{{language.investingbyriskq12note}}</em></p>
        <h6 class="title-label">
          <span rel="border-circle"><em>12</em></span>
          <span class="text">{{language.investingbyriskquestion12}}</span>
        </h6>
        <ul class="list-form list-unstyled row">
          <li class="col-sm-4 col-md-4 col-lg-4">
            <label class="radio-inline  icheck-label icheck[24aei] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_12" (returnSelectValue)="setQuestionTwelveScore($event)"
                [choiceValue]="1" [checked]="q12_1"></app-radio>
              {{language.investingbyriskq12answer1}}
            </label>
          </li>
          <li class="col-sm-4 col-md-4 col-lg-4">
            <label class="radio-inline  icheck-label icheck[0owkc] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_12" (returnSelectValue)="setQuestionTwelveScore($event)"
                [choiceValue]="1" [checked]="q12_2"></app-radio>
              {{language.investingbyriskq12answer2}}
            </label>
          </li>
          <li class="col-sm-4 col-md-4 col-lg-4">
            <label class="radio-inline  icheck-label icheck[76614] needsclick">
              <app-radio name="STR_RISK_TEST_QUESTION_12" (returnSelectValue)="setQuestionTwelveScore($event)"
                [choiceValue]="1" [checked]="q12_3"></app-radio>
              {{language.investingbyriskq12answer3}}
            </label>
          </li>
        </ul>
      </section>
      <!-- /12 -->

      <footer class="text-center">
        <div class="not-robot">
          <!-- <img src="/img/not-robot.jpg" class="" alt="ex not robot"/> -->
        </div>
        <app-button text="{{language.investingbyrisksumary}}" (click)="xxxFormClick(clickForm)"></app-button>
      </footer>
    </form>
  </section>
</div>